import { render, staticRenderFns } from "./CustomerContactManagementModal.vue?vue&type=template&id=bb5a4412&"
import script from "./CustomerContactManagementModal.vue?vue&type=script&lang=js&"
export * from "./CustomerContactManagementModal.vue?vue&type=script&lang=js&"
import style0 from "./CustomerContactManagementModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports